import LayoutEmbed from "./layout-embed";

export default LayoutEmbed;